<template>
  <v-img
    src="../assets/eventlogo.png"
    max-width="1280px"
    class="ma-auto w-100 w-md-80"
  >
    <template #sources>
      <source srcset="../assets/eventlogo.webp" />
    </template>
  </v-img>
  <div>
    <p class="catch text-h4 text-md-h3 text-primary">
      第二回開催！<br />2024年2月25日(日)<br />時間:11時～17時
    </p>
  </div>
</template>
<style scoped>
  .catch {
    text-align: center;
    font-family: "rocknroll-one", sans-serif !important;
    font-weight: bold;
    font-style: normal;
    text-shadow: 0.04em 0.02em 0 #fff,
      0.08em 0.05em 0 rgb(var(--v-theme-secondary));
    line-height: 1.5em;
  }
</style>
